/** Stores a small list of valid product IDs. Browsing must work without storage. */
export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts';
  static #MAX_PRODUCTS = 4;

  static addProduct(productId) {
    const id = String(productId);
    if (!/^\d+$/.test(id)) return;
    const products = [id, ...this.getProducts().filter((value) => value !== id)].slice(0, this.#MAX_PRODUCTS);
    try { localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(products)); } catch { /* Storage is optional. */ }
  }

  static clearProducts() {
    try { localStorage.removeItem(this.#STORAGE_KEY); } catch { /* Storage is optional. */ }
  }

  static getProducts() {
    try {
      const stored = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
      if (!Array.isArray(stored)) { this.clearProducts(); return []; }
      return [...new Set(stored.filter((id) => typeof id === 'string' || typeof id === 'number').map(String).filter((id) => /^\d+$/.test(id)))].slice(0, this.#MAX_PRODUCTS);
    } catch { this.clearProducts(); return []; }
  }
}
